import {Menu, MenuItem, makeStyles} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        'font-size': '0.75rem',
    },
}));

const ITEM_HEIGHT = 48;

export default function MoreMenu(props){
    const {anchorEl, menuOpen, row, onClick, onClose, menuOptions, autoFocus, displayFunction, keyFunction} = props;
    const classes = useStyles();

    if (!menuOptions){
        return null;
    }

    return (
        <React.Fragment>
            <Menu
                id="more-menu"
                anchorEl={anchorEl}
                keepMounted
                open={menuOpen}
                onClose={onClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                    },
                }}
                autoFocus={autoFocus}
            >
                {menuOptions != null && menuOptions.length > 0 && menuOptions.map((option, index) => (
                    <MenuItem key={'menu-'+index+keyFunction(option)} onClick={onClick} classes={{root: classes.root}}
                        autoFocus={autoFocus} value={keyFunction(option)}>
                        {displayFunction(option)}
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    );
}